import {MouseEventHandler} from "react";
import {css} from "@panda/css";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";

import {useResponsiveLinkTarget} from "../hooks/use_responsive_link_target";

interface IProps {
    href?: string;
    label: string;
    linkText: string;
    dataTestId?: string;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
    onMouseDown?: MouseEventHandler<HTMLAnchorElement>;
}

export const LinkWithLabel = (props: IProps) => {
    const {href, label, linkText, dataTestId, onClick, onMouseDown} = props;

    const target = useResponsiveLinkTarget();

    return (
        <div className={linkWithLabel} data-testid={dataTestId}>
            <div className={flexWrapper}>
                <Text variant="info_txt_1" color="var(--colors-gray-700)">
                    {label}
                </Text>

                {href ? (
                    <Link href={href} size="small" target={target} textClassName={linkTextStyle} onClick={onClick} onMouseDown={onMouseDown}>
                        {linkText}
                    </Link>
                ) : (
                    <Text variant="info_txt_1" className={linkTextStyle}>
                        {linkText}
                    </Text>
                )}
            </div>
        </div>
    );
};

const linkWithLabel = css({
    display: "flex",
    alignItems: "center",
    mb: "0.5rem"
});

const flexWrapper = css({
    display: "flex",
    alignItems: "center",
    gap: "0.3rem"
});

const linkTextStyle = css({
    display: "flex",
    textDecoration: "underline"
});
import {MouseEventHandler} from "react";
import {css} from "@panda/css";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";

import {useResponsiveLinkTarget} from "../hooks/use_responsive_link_target";

interface IProps {
    href?: string;
    label: string;
    linkText: string;
    dataTestId?: string;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
    onMouseDown?: MouseEventHandler<HTMLAnchorElement>;
}

export const LinkWithLabel = (props: IProps) => {
    const {href, label, linkText, dataTestId, onClick, onMouseDown} = props;

    const target = useResponsiveLinkTarget();

    return (
        <div className={linkWithLabel} data-testid={dataTestId}>
            <div className={flexWrapper}>
                <Text variant="info_txt_1" color="var(--colors-gray-700)">
                    {label}
                </Text>

                {href ? (
                    <Link href={href} size="small" target={target} textClassName={linkTextStyle} onClick={onClick} onMouseDown={onMouseDown}>
                        {linkText}
                    </Link>
                ) : (
                    <Text variant="info_txt_1" className={linkTextStyle}>
                        {linkText}
                    </Text>
                )}
            </div>
        </div>
    );
};

const linkWithLabel = css({
    display: "flex",
    alignItems: "center",
    mb: "0.5rem"
});

const flexWrapper = css({
    display: "flex",
    alignItems: "center",
    gap: "0.3rem"
});

const linkTextStyle = css({
    display: "flex",
    textDecoration: "underline"
});
